export const NOTIFICATION_IDS = {
  PHOTO_AI_FEEDBACK: 'photo-ai-feedback-notification'
}
